import EventEmitter from 'eventemitter3';
export const PageLifecycleStates = {
    ACTIVE: 'active',
    PASSIVE: 'passive',
    HIDDEN: 'hidden',
    FROZEN: 'frozen',
    TERMINATED: 'terminated',
    DISCARDED: 'discarded',
};
export const PageLifecycleVisibleStates = [
    PageLifecycleStates.ACTIVE,
    PageLifecycleStates.PASSIVE,
];
export class PageLifecycleWatcher extends EventEmitter {
    #wasInitialized = false;
    #state;
    get wasInitialized() {
        return this.#wasInitialized;
    }
    get state() {
        return this.#state;
    }
    get isVisible() {
        return PageLifecycleVisibleStates.includes(this.#state);
    }
    init() {
        if (this.#wasInitialized) {
            return;
        }
        this.#wasInitialized = true;
        this.#state = this.#getState();
        const opts = { capture: true };
        const onStateChange = () => this.#transitionTo(this.#getState());
        ['visibilitychange', 'focus', 'blur'].forEach((type) => {
            window.addEventListener(type, onStateChange, opts);
        });
        window.addEventListener('pageshow', (event) => {
            this.#transitionTo(this.#getState());
        }, opts);
        window.addEventListener('freeze', () => {
            this.#transitionTo(PageLifecycleStates.FROZEN);
        }, opts);
        window.addEventListener('pagehide', (event) => {
            if (event.persisted) {
                this.#transitionTo(PageLifecycleStates.FROZEN);
            }
            else {
                this.#transitionTo(PageLifecycleStates.TERMINATED);
            }
        }, opts);
    }
    #transitionTo(nextState) {
        const prevState = this.#state;
        if (nextState !== prevState) {
            this.#state = nextState;
            this.emit('change', this.#state);
        }
    }
    #getState() {
        if (document.visibilityState === 'hidden') {
            return PageLifecycleStates.HIDDEN;
        }
        if (document.hasFocus()) {
            return PageLifecycleStates.ACTIVE;
        }
        return PageLifecycleStates.PASSIVE;
    }
}
export const pageLifeCycleWatcher = new PageLifecycleWatcher();
